import { fetchReport } from '../../../services/reportsApi';
import type { ReservationLogRequestParams, TodayNewDetailsRequestParams } from './reservationReportActions';

const REPORTS_BASE_URL = process.env.REACT_APP_API_ENDPOINT_REPORTS || '';

export const getReservationSummaryApi = (locationId: string, date?: string) => {
  const params = new URLSearchParams({ locationId });
  if (date) params.set('date', date);
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/summary?${params}`);
};

export const getReservationCheckinKpiApi = (locationId: string, date?: string) => {
  const params = new URLSearchParams({ locationId });
  if (date) params.set('date', date);
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/checkin-kpi?${params}`);
};

export const getReservationLogApi = ({
  locationId,
  page,
  size,
  sortBy,
  sortDir,
  search,
  status,
  date,
}: ReservationLogRequestParams) => {
  const params = new URLSearchParams({ locationId, page: String(page), size: String(size), sortBy, sortDir });
  if (search) params.set('search', search);
  if (status) params.set('status', status);
  if (date) params.set('date', date);
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/log?${params}`);
};

export const getReservationDetailApi = ({
  locationId,
  reservationId,
}: {
  locationId: string;
  reservationId: string;
}) => {
  const params = new URLSearchParams({ locationId, reservationId });
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/detail?${params}`);
};

export const getReservationByStatusApi = (locationId: string, date?: string) => {
  const params = new URLSearchParams({ locationId });
  if (date) params.set('date', date);
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/by-status?${params}`);
};

export const getReservationHourlyApi = (locationId: string, date?: string) => {
  const params = new URLSearchParams({ locationId });
  if (date) params.set('date', date);
  return fetchReport(`${REPORTS_BASE_URL}/reservation/v1/hourly?${params}`);
};

export const getTodayNewDetailsApi = ({
  locationId,
  startDate,
  endDate,
  page,
  size,
  search,
  sortBy,
  sortAsc,
}: TodayNewDetailsRequestParams) => {
  const params = new URLSearchParams({
    locationId,
    startDate,
    endDate,
    page: String(page + 1),
    size: String(size),
  });
  if (search) params.set('search', search);
  if (sortBy) params.set('sortBy', sortBy);
  if (sortBy) params.set('sortAsc', String(sortAsc ?? true));
  return fetchReport(`${REPORTS_BASE_URL}/reservations/today-reservation/today-live-reservations?${params}`);
};
